import { cn } from '@/lib/utils';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-sm bg-linear-to-r from-[#E5E1D6] to-[#F5F2ED]',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
